import React, { useState } from "react";
import { CalendarDay } from "../../calendar/utils";
import { HORIZONTAL_RULE_COLOR, RUBRIC_COLOR } from "../../tokens";
import { useDataDependency } from "../../utils/RemoteDataProvider";
import { LessonData, ReadingsSetting } from "../../utils/settings";
import { LoadingScreen } from "../pray/LoadingScreen";
import { Scripture } from "../pray/Scripture";

export const CheckLessonsRow: React.FC<{
    day: CalendarDay;
    readings: ReadingsSetting;
}> = (props) => {
    const { day, readings } = props;

    const loadableLessons = useDataDependency<{
        firstLesson: LessonData;
        secondLesson: LessonData;
    }>({
        type: "mattins readings",
        day,
        mattinsReadings: readings,
        bibleTranslation: "ESV",
        refsOnly: false,
    });

    const [isOpened, setIsOpened] = useState(false);

    return (
        <div
            style={{
                borderTop: `1px dashed ${HORIZONTAL_RULE_COLOR}`,
            }}
        >
            {loadableLessons.state === "loaded" ? (
                <>
                    <div
                        style={{ display: "flex", padding: 4, fontSize: "90%" }}
                    >
                        <div
                            style={{
                                width: 100,
                            }}
                        >
                            {day.dayOfTheWeek.toLocaleUpperCase()} {day.month}/
                            {day.date} {day.label}
                        </div>
                        <div style={{ width: 240 }}>
                            (
                            {Math.round(
                                loadableLessons.value.firstLesson
                                    .map((part) =>
                                        part.content
                                            .map((line) => line.text.length)
                                            .reduce((a, b) => a + b, 0)
                                    )
                                    .reduce((a, b) => a + b, 0) / 100
                            ) / 10}
                            k){" "}
                            {loadableLessons.value.firstLesson
                                .map((part) => part.title)
                                .join("; ")}
                        </div>
                        <div style={{ width: 240 }}>
                            (
                            {Math.round(
                                loadableLessons.value.secondLesson
                                    .map((part) =>
                                        part.content
                                            .map((line) => line.text.length)
                                            .reduce((a, b) => a + b, 0)
                                    )
                                    .reduce((a, b) => a + b, 0) / 100
                            ) / 10}
                            k){" "}
                            {loadableLessons.value.secondLesson
                                .map((part) => part.title)
                                .join("; ")}
                        </div>
                        <div
                            style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                                color: RUBRIC_COLOR,
                            }}
                            onClick={() => setIsOpened(!isOpened)}
                        >
                            Show/Hide
                        </div>
                    </div>
                    <div
                        style={{
                            maxHeight: isOpened ? 10000 : 0,
                            overflow: "hidden",
                            opacity: isOpened ? 1 : 0,
                            transition: "all 0.3s",
                            paddingBottom: isOpened ? 48 : 0,
                        }}
                    >
                        {loadableLessons.value.firstLesson.map(
                            (lessonPart: { title: string; content: any }) => {
                                return (
                                    <Scripture
                                        title={lessonPart.title}
                                        content={lessonPart.content}
                                        key={lessonPart.title}
                                        hasBeginneth={false}
                                    />
                                );
                            }
                        )}
                        {loadableLessons.value.secondLesson.map(
                            (lessonPart: { title: string; content: any }) => {
                                return (
                                    <Scripture
                                        title={lessonPart.title}
                                        content={lessonPart.content}
                                        key={lessonPart.title}
                                        hasBeginneth={false}
                                    />
                                );
                            }
                        )}
                    </div>
                </>
            ) : (
                <LoadingScreen />
            )}
        </div>
    );
};
